export default {
    changeCreditLimitErrorAccountNotActive:
        'Denne kontoen er ikke aktiv, vennligst ta kontakt med Eika Kundesenter ved endring av kredittgrense.',
    changeCreditLimitErrorAccountOverdue:
        'Det er purring på denne kontoen, vennligst ta kontakt med Eika Kundesenter ved endring av kredittgrense.',
    changeCreditLimitErrorTitle: 'Beklager, det oppstod et problem',
    changeCreditLimitErrorWarning:
        'Vi klarte dessverre ikke å endre kredittgrensen akkurat nå. Vennligst prøv igjen senere, eller kontakt Eika Kundesenter for hjelp.',
    creditLimitGenericErrorTitle: 'Uventet feil',
    creditLimitGenericErrorWarning:
        'Det oppstod en feil. Vennligst prøv igjen senere, eller ta kontakt med kundesenteret om du trenger hjelp.',
    creditLimitDisplayAmount: 'Kredittgrense {}',

    decreaseCreditCardMessageTipsTitle: 'Vil du senke grensen?',
    decreaseCreditCardMessageTipsText:
        'Dersom du reduserer kredittgrensen din, må du søke på nytt for å øke den igjen senere.',
    decreaseCreditCardSelectAmount: 'Velg beløp',
    decreaseCreditCardMessageSuccessText: 'Kredittgrensen er satt ned',
    decreaseCreditCardMessagePrevent1: 'Du kan dessverre ikke senke grensen.',
    decreaseCreditCardMessagePrevent2Title: 'Minstegrense er {} kr',
    decreaseCreditCardMessagePrevent2: 'Du kan dessverre ikke gå lavere enn dette.',
    decreaseCreditCardMessagePrevent3Title: 'Du har brukt {} kr',
    decreaseCreditCardMessagePrevent3: 'Du kan dessverre ikke senke grensen. Da må du først betale ned på kortet.',
    decreaseCreditCardMessageFooterText: 'Mellom {} og {} kr',
    decreaseCreditCardMessageSuccess: 'Ny kredittgrense på ditt {} er nå endret til {} kr.',
    decreaseCreditButton: 'Senk {} kr',
    increaseCreditButton: 'Øk {} kr',
    decreaseCreditLimitHeader: 'Senk grensen',
};
